// extracted by mini-css-extract-plugin
module.exports = {"root":"LandownerBanner_root__2K4_J","cta":"LandownerBanner_cta__3GzGW","close":"LandownerBanner_close__3WdZp"};